var $ = require("jquery");
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");
require("flickity-imagesloaded");
var LazyLoad = require("vanilla-lazyload");
var fitvids = require("fitvids");

// make Flickity a jQuery plugin
Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);
// now you can use $().flickity()
fitvids();
function isTouchDevice() {
  return "ontouchstart" in document.documentElement;
}
const appHeight = () => {
  if (isTouchDevice() == true) {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  }
};
appHeight();

$(document).ready(function() {
  initNav();
  initCarousels();
  initLazyLoad();
  initHomepage();
  initSocialLinks();
  initVideoControls();
  if (isTouchDevice() == false) {
    initBackgroundImages();
  }

  setTimeout(function() {
    $(".logo.fa-spin").removeClass("fa-spin");
  }, 1000);
});

var initNav = function() {
  $(".nav-toggle").on("touchstart click", function(e) {
    e.preventDefault();
    $("body").toggleClass("primary-nav-open");
  });

  var scrollTop = 0;
  $(window).on("scroll", function() {
    var s = window.pageYOffset || document.documentElement.scrollTop;
    if (s > scrollTop) {
      $("body").addClass("hide-nav");
    } else {
      $("body").removeClass("hide-nav");
    }
    scrollTop = s;

    if (scrollTop == 0) {
      $("body").removeClass("hide-icon");
    } else {
      $("body").addClass("hide-icon");
    }
  });

  $(".back-to-top").on("click", function(e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0
      },
      500
    );
  });
};

var initCarousels = function() {
  var $carousel = $(".carousel").flickity({
    wrapAround: true,
    initialIndex: 0,
    pageDots: false,
    prevNextButtons: true,
    adaptiveHeight: true,
    imagesLoaded: true
  });

  var $heroCarousel = $(".hero-carousel");
  $heroCarousel.flickity({
    wrapAround: true,
    initialIndex: Math.floor(Math.random() * $heroCarousel.children.length),
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    pauseAutoPlayOnHover: false,
    imagesLoaded: true,
    autoPlay: 8000
  });
};

var initLazyLoad = function() {
  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    threshold: 0
  });
};

var initHomepage = function() {
  $(".down-arrow").on("touchstart click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $("html, body").animate(
      {
        scrollTop: $(".page-section--project-card-listing").offset().top
      },
      500
    );
  });
};

var initSocialLinks = function() {
  $(".toggle-social-links").on("click", function(e) {
    e.preventDefault();
    $(this).addClass("disable");
    $(this)
      .parents(".social-links")
      .find(".share-links")
      .addClass("active");
  });

  $(".share-links").on("mouseleave", function() {
    $(this).removeClass("active");
    $(".toggle-social-links").removeClass("disable");
  });

  if ($(".share-facebook").length) {
    $(".share-facebook").on("click", function(e) {
      e.preventDefault();
      var u = location.href;
      var t = document.title;
      var url =
        "http://www.facebook.com/sharer.php?u=" +
        encodeURIComponent(u) +
        "&t=" +
        encodeURIComponent(t);
      window.open(url, "sharer", "toolbar=0,status=0,width=626,height=436");
    });
  }

  if ($(".share-twitter").length) {
    $(".share-twitter").on("click", function(e) {
      e.preventDefault();
      var u = location.href;
      var url = "http://twitter.com/share?url=" + encodeURIComponent(u);
      window.open(url, "sharer", "toolbar=0,status=0,width=626,height=436");
    });
  }
};

const initVideoControls = function() {
  $(".video-wrap .play-btn").on("click", function(e) {
    e.preventDefault();
    var videoWrap = $(this).parents(".video-wrap"),
      video = $(videoWrap).find("video")[0];
    if ($(videoWrap).hasClass("playing")) {
      $(videoWrap).removeClass("playing");
      video.pause();
    } else {
      $(videoWrap).addClass("playing");
      video.play();
    }
  });

  $(".video-wrap .play-btn").each(function(idx, elem) {
    var video = $(elem)
      .parents(".video-wrap")
      .find("video")[0];
    video.onended = function() {
      $(elem)
        .parents(".video-wrap")
        .removeClass("playing");
      video.currentTime = 0;
    };
  });
};

const initBackgroundImages = function() {
  $("[data-image] a")
    .on("mouseenter", function() {
      if (
        $(this)
          .parents("[data-image]")
          .attr("data-image") != ""
      ) {
        var that = $(this).parents("[data-image]"),
          image = that.attr("data-image");

        if ($(".fixed-image").length <= 0) {
          that
            .parents(".page-section")
            .append(
              '<div class="fixed-image" style="display:none; background:url(' +
                image +
                ') no-repeat transparent 50% 50%;pointer-events:none;background-size:contain;width:80%;height:80%;z-index:20;position:fixed;top:10%;left:10%;"></div>'
            );

            $('.fixed-image').fadeIn();
        }
      }
    })
    .on("mouseout", function() {
      $(".fixed-image").fadeOut(function(){
        $(this).remove();
      });
    });
};
